import { useState } from "react";
import axios from "axios";
import { Download, FileCheck2, Loader2, LockKeyhole } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OperatorHandbook() {
  const [downloading, setDownloading] = useState(false);

  const downloadHandbook = async () => {
    setDownloading(true);
    try {
      const response = await axios.get(`${API}/admin/documents/operator-handbook`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Betreiberhandbuch_Unfallmeldungs_Tool.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Betreiberhandbuch wurde heruntergeladen");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Download fehlgeschlagen");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-10 animate-fade-in" data-testid="operator-handbook-page">
      <header className="border-b border-zinc-800 pb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-500 mb-3">VERTRAULICH · SUPER-ADMIN</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-zinc-50">Betreiberhandbuch</h1>
        <p className="text-base text-zinc-400 mt-4 max-w-2xl">
          Deine private Übersicht über Funktionen, Datenbestände, Speicherorte, Zugriffe, Sicherungen und Verantwortlichkeiten.
        </p>
      </header>

      <section className="grid gap-5 md:grid-cols-2">
        <div className="border border-zinc-800 bg-zinc-900/50 p-6 rounded-sm">
          <FileCheck2 className="w-7 h-7 text-yellow-500 mb-5" />
          <h2 className="text-lg font-bold text-zinc-50">Geprüfte PDF</h2>
          <p className="text-sm text-zinc-400 mt-2">15 Seiten im A4-Format, vollständig geprüft und ohne Zugangsdaten oder geheime Schlüssel.</p>
        </div>
        <div className="border border-zinc-800 bg-zinc-900/50 p-6 rounded-sm">
          <LockKeyhole className="w-7 h-7 text-yellow-500 mb-5" />
          <h2 className="text-lg font-bold text-zinc-50">Geschützter Zugriff</h2>
          <p className="text-sm text-zinc-400 mt-2">Der Download wird nur nach Anmeldung mit einem globalen Super-Admin-Konto ausgeliefert.</p>
        </div>
      </section>

      <div className="border-t border-zinc-800 pt-8">
        <Button
          type="button"
          onClick={downloadHandbook}
          disabled={downloading}
          data-testid="download-operator-handbook-button"
          className="bg-yellow-500 text-black hover:bg-yellow-400 font-bold min-w-56"
        >
          {downloading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
          {downloading ? "Download läuft…" : "PDF herunterladen"}
        </Button>
      </div>
    </div>
  );
}